export default {
    NOTIFICATION_ADDED: 'NOTIFICATION_ADDED',
    NOTIFICATION_REMOVED: 'NOTIFICATION_REMOVED',
};
